import { gql } from "@apollo/client";
import { mutations, queries } from "@/graphql";

// Legacy GraphQL constant compatibility layer.
// Keep these exports to support existing imports from "@/hooks".
// export const ADD_DEAL = mutations.addDeal;
export const ADD_TENANT = mutations.addTenant;
export const DELETE_TENANT = mutations.deleteTenant;
export const ADD_USER_BY_ADMIN = mutations.addUserByAdmin;
export const CHANGE_PASSWORD_MUTATIION = mutations.changePasswordMutatiion;
export const CONSUMPTION_ENERGY_DATA = queries.energyData;
export const CUSTOMERS = queries.customers;
export const ENERGY_DATA = queries.energyData;
export const GENERATE_COST_STATEMENT_FILE = queries.generateCostStatementFile;
export const GENERATE_ENERGY_STATEMENT_FILE =
  queries.generateEnergyStatementFile;
export const GENERATE_TARIFF_STATEMENT_FILE =
  queries.generateTariffStatementFile;
export const GET_ACTIVE_USERS = queries.getActiveUsers;
export const GET_ALL_PARTNERS = queries.getAllPartners;
// export const GET_COMPANIES_BUILDINGS = queries.getCompaniesBuildings;
// export const GET_COUNTRIES = queries.getCountries;
export const GET_DEALS_LIST = queries.getDealsList;
export const GET_GROUPS = queries.getGroups;
export const GET_METERS_DATA_QUERY = queries.getMetersDataQuery;
export const GET_BUDGET_DATA_QUERY = queries.budgetData;
export const GET_SCRAPPER_LIST = queries.getScrapperList;
export const GET_SCRAPPER_LOGS = queries.getScrapperLogs;
export const GET_SETTINGS = queries.getSettings;
export const GET_USERS_LIST = queries.getUsersList;
export const LOGIN = mutations.login;
export const LOGIN_AS = mutations.loginAs;
export const ME = queries.me;
export const MONTHLY_STATEMENT_DATA = queries.monthlyStatementData;
export const PARTNERS_USERS_LIST = queries.getPartnerUsersList;
export const REGISTER = mutations.register;
export const TENANTS_COMPANIES_LIST = queries.tenantsCompaniesList;
export const TENANTS_LIST = queries.tenantsList;
export const TENANTS_USERS_LIST = queries.tenantsUsersList;
export const UPDATE_CURRENT_USER_PROFILE = mutations.updateCurrentUserProfile;
export const UPDATE_PARTNER = mutations.updatePartner;
export const UPDATE_TENANT = mutations.updateTenant;
export const UPDATE_USER_BY_ADMIN = mutations.updateUserByAdmin;
export const VERIFY_REGISTERED_EMAIL = mutations.verifyRegisteredEmail;

export const GET_ALL_ROLES = gql`
  query getAllRoles($role: String) {
    roles(role: $role) {
      id
      role
      key
      modules
      createdAt
      updatedAt
      value: id
      label: role
    }
  }
`;

export const GET_ROLES_ONLY = GET_ALL_ROLES;

export const USER_DOCUMENTS = gql`
  query userDocuments(
    $energyType: String
    $subsidiary: String
    $customer: String
    $tenant: String
    $documentId: String
  ) {
    userDocuments(
      energyType: $energyType
      subsidiary: $subsidiary
      customer: $customer
      tenant: $tenant
      documentId: $documentId
    ) {
      id
      name
      energyType
      documentType
      startDate
      endDate
    }
  }
`;

export * from "./moment";
export * from "./images";
export * from "./permissions";
export * from "./users";
export * from "./settings";
export * from "./companies";
export * from "./energy";
export * from "./common";
export * from "./partners";
// @ts-ignore
// @ts-expect-error
export * from "./notifications";
